import React from "react";

const Beta = () => {
  return (
    <section id="beta">
        <div className="px-4 py-4 container-fluid">
            <div className="row no-gutters">
                <div className="col-10 offset-1 text-center">
                    <h4>Project is still in βeta version. Use it at your own risk. If you found a bug, please let us know!</h4>
                </div>
            </div>
        </div>
    </section>
  )
};

export default Beta;